const CardType = {
  LOGO: 'logo',
  BACKGROUND: 'background',
  THUMBNAIL: 'thumbnail',
  CARD_ACTIVATION_NUMBER: 'cardActivationNumber',
  CARD_LAST_DIGITS: 'cardLastDigits',
  LANDING_PAGE: 'landingPage',
};

const getCardAssetURL = (client, type) => {
  if (!client && Object.values(CardType).includes(type)) {
    return require(`./cards/default/${type}.webp`).default;
  }

  return `/assets/${client}/${type}.webp`;
};

export { getCardAssetURL, CardType };
